/**
 * Gets the localized name from a name record, preferring English.
 * Falls back to the first available language or 'Unnamed' if empty.
 */
export const getLocalizedName = (name: Record<string, string>): string => {
    return name['en'] || Object.values(name)[0] || 'Unnamed';
};
